"use strict";

exports.__esModule = true;
exports.saveForumDisplayState = saveForumDisplayState;
exports.getForumDisplayState = getForumDisplayState;
exports.FORUM_DISPLAY_STATE = void 0;
var FORUM_DISPLAY_STATE = 'forum-display-state';
exports.FORUM_DISPLAY_STATE = FORUM_DISPLAY_STATE;

function saveForumDisplayState(value) {
  if (isSessionStorageAvailable()) {
    sessionStorage.setItem(FORUM_DISPLAY_STATE, value);
  }
}

function getForumDisplayState() {
  if (isSessionStorageAvailable()) {
    return sessionStorage.getItem(FORUM_DISPLAY_STATE);
  }
}

function isSessionStorageAvailable() {
  // session storage is unavailable and throws exception when third party cookies are blocked
  try {
    if (typeof sessionStorage === 'undefined') {
      return false;
    }

    if (!sessionStorage.getItem || !sessionStorage.setItem) {
      return false;
    }
  } catch (e) {
    return false;
  }

  return true;
}